import React, { useEffect, useState } from 'react';
import { authClient } from '../../redux/api/Client';
import styles from './apiresponse-container.module.sass';
import { baseURL } from '../../redux/api/Manifest';
import { Button, Spin, Tooltip } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as copy_icon } from '../../assets/icons/Copy.svg';
import {
  infoNotification,
  showNotification,
} from '../../shared-components/Notifications';
import { useDispatch } from 'react-redux';
import { changeTitle } from '../../redux/actions/app';

export default function APIResponseContainer(props) {
  const dispatch = useDispatch();
  const { location } = props;
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [endpoint, setEndpoint] = useState('');
  const CopyIcon = (props) => <Icon component={copy_icon} {...props} />;

  const copyAPIURL = () => {
    navigator.clipboard.writeText(
      `https://api.silentpush.com/api/v1/${endpoint}`,
    );
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
  };

  useEffect(() => {
    document.title = 'API Response - Silent Push';
  }, []);

  useEffect(() => {
    dispatch(changeTitle('API Response', null));
    const getResponse = async (endpoint) => {
      return authClient.Base.base_api({ host: `${baseURL}/api/v1/${endpoint}` })
        .then((res) => res.data())
        .then((res) => setData(res));
    };
    const pathname = location.pathname;
    const mergeApiPath = pathname.replace('/data/', '');
    if (pathname === '/data' || pathname === '/data/') {
      props.history.push('/');
      return () => {};
    }
    setEndpoint(mergeApiPath + location.search);
    getResponse(mergeApiPath + location.search).finally(() => {
      setLoading(false);
    });
  }, [location.pathname, location.search]);
  return (
    <>
      {loading && (
        <div className={styles['spinner-container']}>
          <Spin spinning={loading} />
        </div>
      )}
      {!loading && (
        <div className={styles['api-response-container']}>
          <p
            style={{
              color: 'white',
              fontWeight: 'bold',
              padding: '15px 15px 0 15px',
            }}
          >
            This is the HTML response and it's not suitable for any integration
            tools like "Postman", "Azure", "cURL" etc. For that purpose use this
            endpoint.
            <Tooltip title="Copy API URL">
              <Button
                icon={<CopyIcon />}
                style={{
                  background:
                    'rgba(255, 255, 255, 0.08) none repeat scroll 0% 0%',
                  border: 'medium none',
                  borderRadius: 4,
                  display: 'inline',
                  color: 'white',
                  marginLeft: 5,
                }}
                onClick={() => copyAPIURL()}
              >
                Copy API URL
              </Button>
            </Tooltip>
          </p>
          <pre className={styles['json-block']}>
            {JSON.stringify(data, null, 2)}
          </pre>
        </div>
      )}
    </>
  );
}
